export default (value, bbrbbr) => {
  if (value) {
    let bundesbruder = 'Kein Kontakt gefunden'
    let bbr = bbrbbr.find(bbr => bbr.id === value)
    if (bbr) {
      bundesbruder = bbr.nachname + ', ' + bbr.vorname
    }
    return bundesbruder
  } else {
    return
  }
}



// WEBPACK FOOTER //
// ./src/filters/user.js